export default function OCRReader(url = ""){

    // holds expected type of message
    const expectedTypes = ["CardContentText", "Images"];

    // holds received message
    const receivedData = {};


    return new Promise((resolve, reject) => {
        // creating socket instance
        const socket = new WebSocket(url);
    
        // when socket connection is estabished
        socket.onopen = async () => {
            console.log("WebSocket connected");

            let request_data = {
                "Type": "Request",
                "Commands": [
                    {"Command": "Set", "Operand": "RFID", "Param": "Y"},
                    {"Command": "Set", "Operand": "VIZ", "Param": "Y"}
                ]
            }

            let message = JSON.stringify(request_data);

            await socket.send(message)

            // setting timeout to close socket
            setTimeout(() => {
                if(socket){
                    socket.close();
                }
            }, 15000)
        };
    
        // receiving message from socket
        socket.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);

                if (data.Command == 'Save' && expectedTypes.includes(data.Operand))
                {
                    if(data.Operand == "CardContentText"){
                        receivedData['card'] = data.Param
                    }else if(data.Operand == "Images"){
                        receivedData['image'] = data.Param
                    }
                }


                const received_type = Object.keys(receivedData);


                // Check if all expected types have been received
                if (['card', 'image'].every(type => received_type.includes(type))) {                    
                    socket.close();
                    resolve(receivedData);
                }
                
            } catch (err) {
                console.error("Error parsing message:", err);
                reject(err);
            }
        };
        
        socket.onclose = () => {
            reject();
            console.log("WebSocket closed");
        };
    
        // in case of exception
        socket.onerror = (err) => {
            reject(err)
            console.error("WebSocket error:", err);
        };
    })
}